/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PublicPlaceInformationDto } from './publicPlaceInformationDto';


export interface PublicLocationSummaryDto { 
    id?: number;
    displayName?: string;
    address1?: string;
    address2?: string;
    city?: string;
    postalCode?: string;
    county?: string;
    country?: string;
    lat?: number;
    lng?: number;
    hq?: boolean;
    placeInformation?: PublicPlaceInformationDto;
}

